import React, { useCallback, useState } from 'react';
import { DashboardEditor, DashboardView as UIDashboardView } from '@leverege/ui-dashboard';
import { Pane, Content } from '@leverege/ui-elements';
import { Config } from '@leverege/plugin';
import { Toolbar } from '@leverege/ui-plugin';
import I18N from '@leverege/i18n';
import { ModelFactory, EditorFactory, ViewerFactory, OptionEditorFactory } from "./Factory.js";
import getModelCreators from "./Creators.js";
import S from './DashboardView.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.dataViewers.dashboard.DashboardView');
const defaultVariants = [{
  get name() {
    return t('default');
  },
  value: null
}, {
  get name() {
    return t('grid');
  },
  value: 'grid'
}, {
  get name() {
    return t('section');
  },
  value: 'section'
}, {
  get name() {
    return t('transparent');
  },
  value: 'transparent'
}, {
  get name() {
    return t('secondary');
  },
  value: 'secondary'
}, {
  get name() {
    return t('tertiary');
  },
  value: 'tertiary'
}];
function DashboardView(props) {
  const {
    settingsPath,
    relationship,
    objectType,
    settings,
    settingsData,
    onSettingsChange,
    expanded,
    modelCreators = getModelCreators
  } = props;
  const {
    path
  } = relationship;
  const versionsPath = `${objectType}.dashboard`;
  const matchContext = {
    use: 'actionBar',
    client: DashboardView.CLIENT,
    objectType,
    path
  };
  const dashboard = settings;
  const [editing, setEditing] = useState(false);
  const variants = Config.get('DashboardScreen', 'variants', defaultVariants);
  const onChange = useCallback(evt => {
    onSettingsChange({
      value: evt.value,
      data: settingsData
    });
  }, [settingsData, onSettingsChange]);
  const onSetEditing = () => {
    setEditing(true);
  };
  const onOkay = () => {
    setEditing(false);
  };
  const context = {
    settingsPath,
    versionsPath,
    value: dashboard,
    editor: {
      onChange
    },
    clientProps: {
      ...props,
      editing,
      onOkay,
      onSetEditing,
      dashboard
    }
  };
  return /*#__PURE__*/_jsxs(Content, {
    className: S.content,
    variant: expanded ? 'expandedDashboard' : 'itemDashboard',
    children: [/*#__PURE__*/_jsx(Content.Area, {
      className: editing ? null : S.contentArea,
      children: /*#__PURE__*/_jsxs(Pane, {
        className: S.dashboard,
        variant: expanded ? 'expandedDashboardContent' : 'itemDashboardContent',
        children: [editing && /*#__PURE__*/_jsx(DashboardEditor, {
          addWidgetText: t('addWidgetText'),
          style: {
            flex: 1
          },
          variants: variants,
          value: dashboard,
          models: ModelFactory,
          editors: EditorFactory,
          viewers: ViewerFactory,
          optionEditors: OptionEditorFactory,
          deferEditing: true,
          onChange: onChange,
          options: {
            dateTimeRange: 'last7Days',
            expanded
          },
          objectType: objectType,
          getModelCreators: modelCreators,
          sharedProps: props
        }), !editing && /*#__PURE__*/_jsxs(React.Fragment, {
          children: [/*#__PURE__*/_jsx(UIDashboardView, {
            style: {
              flex: 1,
              height: '100%'
            },
            value: dashboard,
            models: ModelFactory,
            viewers: ViewerFactory,
            optionEditors: OptionEditorFactory,
            sharedProps: props,
            onChange: onChange,
            options: {
              dateTimeRange: 'last7Days',
              expanded
            },
            objectType: objectType,
            getModelCreators: modelCreators,
            variants: variants
          }), !expanded && /*#__PURE__*/_jsx(Toolbar, {
            variant: "actionBarDashboard|actionBar",
            matchContext: matchContext,
            context: context
          })]
        })]
      })
    }), !expanded && /*#__PURE__*/_jsx(Content.Footer, {
      className: S.contentFooter,
      layout: "flex:rowMEnd",
      children: editing && /*#__PURE__*/_jsx(Toolbar, {
        variant: "actionBarDashboard|actionBar",
        matchContext: matchContext,
        context: context
      })
    })]
  });
}
DashboardView.CLIENT = 'molten.dataViewer.DashboardDataViewer';
export default /*#__PURE__*/React.memo(DashboardView);